module.exports = __webpack_public_path__ + "static/media/hrdlička5.cbb871c9.jpg";